/*
* @Author: your name
* @Date: 2020-05-15 14:08:29
* @LastEditTime: 2020-05-15 18:41:19
* @LastEditors: Please set LastEditors
* @Description: In User Settings Edit
* @FilePath: \vue-vue\src\main.js
*/


/* eslint-disable */
import Vue from 'vue';
import App from './App';
import router from './router';
import '@/assets/fonts/iconfont.css';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(ToastPlugin, {position: 'top'});

Vue.use(AlertPlugin);
Vue.use(LoadingPlugin);
Vue.config.productionTip = false;

const FastClick = require('fastclick');
FastClick.attach(document.body);
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js